export { default } from "./CreateUser";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/CreateUser/index.js